import { render, staticRenderFns } from "./MandateDataITPSI.vue?vue&type=template&id=4a18c35d&"
import script from "./MandateDataITPSI.vue?vue&type=script&lang=js&"
export * from "./MandateDataITPSI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports